import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { TextField } from '@mui/material'
import { cloneDeep } from 'lodash'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { Button, DialogConfirm } from 'components'
import AddAttachments from 'components/AddAttachments'
import TextFieldFillBar from 'components/TextFieldFillBar'
import { removeAttachment } from 'utils/attachmentOperations'
import { submitOpenQuestion } from 'services/apiKYP'

import styles from './styles'

const initialValues = {
  text: '',
  attachments: [],
}

const initialErrors = {
  text: false,
}

const AdditionalAnswerForm = (props) => {
  const { questionData, handleClose } = props
  const classes = styles()
  const min = 25
  const max = 2000

  const token = useSelector((state) => state.auth.access_token)

  const [formState, setFormState] = useState(initialValues)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)
  const [openOnSubmit, setOpenOnSubmit] = useState(false)
  const [openOnClean, setOpenOnClean] = useState(false)

  const handleTextFieldChange = (event) => {
    const newFormState = cloneDeep(formState)
    const key = event.target.id
    const { value } = event.target
    if (value.length <= max) {
      newFormState[key] = value
      setFormState(newFormState)
    }
  }

  const handleCloseDialog = () => {
    setOpenOnClean(false)
    setOpenOnSubmit(false)
    handleClose()
  }
  
  const closeForm = () => {
    setFormState(initialValues)
    setFormErrors(initialErrors)
    handleCloseDialog()
  }

  const cleanForm = () => {
    const attachments = cloneDeep(formState.attachments)
    if (attachments.length > 0) {
      Promise.all(
        attachments.map((attachment) =>
          removeAttachment(attachment.uuid, token),
        ),
      )
    }
    closeForm()
  }
  

  const handleSubmit = () => {
    setLoading(true)
    submitOpenQuestion(token, questionData.uuid, formState).then(() => {
      toast.success("Resposta enviada com sucesso")
      closeForm()
    }).catch((error) => {
      toast.error(error?.response?.data?.detail)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleOpenOnSubmit = () => {
    setOpenOnSubmit(true)
  }

  const handleOpenOnClean = () => {
    setOpenOnClean(true)
  }

  const handleUpdateAttachments = (attachmentsList) => {
    const newFormState = cloneDeep(formState)
    newFormState.attachments = attachmentsList
    setFormState(newFormState)
  }

  const validateAnwers = () => {
    const newFormErrors = cloneDeep(initialErrors)
    const keys = Object.keys(initialErrors)

    keys.forEach((key) => {
      if (formState[key] === '') {
        newFormErrors[key] = true
      } else if (formState[key].length < min || formState[key].length > max) {
        newFormErrors[key] = true
      }
    })

    setFormErrors(newFormErrors)

    if (keys.some((key) => newFormErrors[key])) {
      toast.error(
        `Verifique o preenchimento do campo, o mesmo não pode esta vazio ou conter menos que ${min} caracteres`,
      )
    } else {
      handleOpenOnSubmit()
    }
  }

  return (
    <div className={classes.root}>
      <h3>Responder pergunta adicional</h3>
      <div className={classes.formWrapper}>
        <p className={classes.questionText}>
          <span>Assunto: </span>
          {questionData.subject}
        </p>
        <p className={classes.questionText}>
          <span>Pergunta: </span>
          {questionData.text}
        </p>
        <TextField
          multiline
          id="text"
          label="Digite sua resposta"
          minRows={5}
          value={formState.text}
          error={formErrors.text}
          onChange={handleTextFieldChange}
          required
          inputProps={{
            sx: {
              fontSize: 14,
            },
          }}
        />
        <TextFieldFillBar
          current={formState?.text?.length}
          min={min}
          max={max}
        />
        <AddAttachments
          attachments={formState.attachments}
          title="Adicione anexos (conforme solicitação):"
          updateAttachments={handleUpdateAttachments}
        />
        <div className={classes.buttonsContainer}>
          <Button
            onClick={handleOpenOnClean}
            variant="text"
            disabled={
              (formState.text.length === 0 &&
                formState.attachments.length === 0) ||
              questionData.answered
            }
          >
            Limpar Formulário
          </Button>
          <Button onClick={validateAnwers} loading={loading}>
            Enviar questão
          </Button>
        </div>
      </div>
      <DialogConfirm
        open={openOnSubmit}
        onConfirm={handleSubmit}
        onCancel={handleCloseDialog}
        title="Tem certeza de que deseja enviar essa questão?"
        btnCancelText="cancelar"
        btnConfirmText="Enviar"
      >
        <div className={classes.questionConfirmation}>
          <p>
            <span>ATENÇÃO: </span>
            após o envio não será possível realizar nenhuma alteração.
          </p>
          <p>
            Por favor verifique a resposta da questão e caso esteja correto
            clique em enviar:
          </p>
          <p>{`"${formState.text}"`}</p>
        </div>
      </DialogConfirm>
      <DialogConfirm
        open={openOnClean}
        onConfirm={cleanForm}
        onCancel={handleCloseDialog}
        title="Tem certeza de que deseja limpar o formulário?"
        btnCancelText="cancelar"
        btnConfirmText="Limpar"
      >
        Esta ação é irreversível e não poderá ser desfeita.
      </DialogConfirm>
    </div>
  )
}

AdditionalAnswerForm.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string,
    subject: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
}

export default AdditionalAnswerForm
